import FilterPopover from './FilterPopover';

const ColumnHeader = ({ column, containerRef }) => {
return (
    <div className="flex items-center justify-between overflow-hidden w-full">
        <span className='truncate' title={column?.columnDef?.header}>
            {column?.columnDef?.header}
        </span>
        <FilterPopover containerRef={containerRef} column={column} /> {/* Use the FilterPopover component */}
    </div>
);
};

export default ColumnHeader;
